// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  html.control-devices-page-lock {
    overflow-y: hidden;
  }

  body:has(.control-devices-page) #root,
  body:has(.control-devices-page) .wrapper,
  .control-devices-page,
  .control-devices-page .layout-container,
  .control-devices-page .layout-page {
    height: 100dvh;
    min-height: 0;
  }

  .control-devices-page {
    overflow: hidden;
  }

  .control-devices-page .content-wrapper,
  .control-devices-page .container-fluid.container-p-y {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .control-devices-page .container-fluid.container-p-y {
    flex-direction: column;
    height: 100%;
  }

  .control-devices-page .control-devices-heading {
    flex: 0 0 auto;
  }

  .control-devices-page .control-devices-table-card {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .control-devices-page .control-devices-table-wrapper {
    height: auto !important;
    min-height: 0;
    max-height: 100%;
    flex: 1 1 auto;
    overflow-y: auto !important;
  }
}

.control-devices-mobile-list {
  display: none;
}

@media (max-width: 1199px) {
  /* En pantallas compactas el menú global se abre desde la hamburguesa como
     panel lateral, sin reservar una columna fija sobre el contenido. */
  body.control-devices-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  body.control-devices-responsive-page .sidenav---sidenav---_2tBP {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 12000;
    width: 0;
    min-width: 0;
    overflow: hidden;
    transform: translateX(-100%);
    transition: width .2s ease, transform .2s ease;
  }

  body.control-devices-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
    width: min(280px, 86vw);
    min-width: min(280px, 86vw);
    overflow-y: auto;
    transform: translateX(0);
    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);
  }

  body.control-devices-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {
    display: block;
  }

  body.control-devices-responsive-page .barra-responsive-offcanvas {
    width: 100vw !important;
    max-width: 100vw !important;
    z-index: 13000;
  }

  body.control-devices-responsive-page .offcanvas-backdrop {
    z-index: 12990;
  }

  /* Igual que el detalle: el color lo aporta el fondo de la pantalla, no una
     capa opaca del navbar. */
  .control-devices-page #layout-navbar.custom-navbar-admin {
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  .control-devices-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .control-devices-page #layout-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .control-devices-page #layout-navbar .app-brand-link img {
    width: min(190px, 100%);
    height: 56px !important;
    object-fit: contain;
    object-position: left center;
  }

  .control-devices-page #layout-navbar .navbar-nav-right {
    position: static;
    transform: none;
    flex: 0 0 auto;
  }

  .control-devices-page #layout-navbar .navbar-actions {
    gap: 4px;
  }
}

@media (max-width: 767px) {
  .control-devices-page {
    min-height: 100dvh;
    overflow-x: hidden;
    background: #f5f7fb;
  }

  .control-devices-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .control-devices-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
  }

  .control-devices-page .content-wrapper {
    padding: 0 12px calc(78px + env(safe-area-inset-bottom));
  }

  .control-devices-page .container-fluid.container-p-y {
    padding: 16px 0 18px !important;
  }

  .control-devices-page .control-devices-heading {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 48px;
    gap: 8px;
    margin: 0 0 14px;
  }

  .control-devices-page .control-devices-heading > [class*="col-"] {
    width: auto;
    max-width: none;
    padding: 0;
  }

  .control-devices-page .control-devices-heading > :first-child {
    grid-column: 1 / -1;
  }

  .control-devices-page .control-devices-heading > :nth-child(2) {
    grid-column: 1;
  }

  .control-devices-page .control-devices-heading > :nth-child(3) {
    grid-column: 2;
  }

  .control-devices-page .label_trafico {
    display: block;
    margin: 0 !important;
    color: #1c3558;
    font-size: 25px !important;
    line-height: 1.15;
    letter-spacing: -0.03em;
  }

  .control-devices-page .input-group {
    height: 48px;
    overflow: hidden;
    border: 1px solid #d9e4ef;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);
  }

  .control-devices-page .input-group-text,
  .control-devices-page #searchDevices {
    border: 0;
    background: #fff;
  }

  .control-devices-page #searchDevices {
    min-width: 0;
    color: #234365;
    font-size: 15px;
  }

  .control-devices-page .control-devices-heading .btn {
    width: 48px;
    height: 48px;
    margin: 0 !important;
    padding: 0;
    border-color: #8fa5bb;
    border-radius: 12px;
    background: #fff;
    color: #4d6c8f;
  }

  .control-devices-page .control-devices-table-wrapper {
    display: none;
  }

  .control-devices-page .control-devices-table-card {
    overflow: visible;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  .control-devices-mobile-list {
    display: grid;
    gap: 12px;
  }

  .control-device-mobile-card {
    overflow: hidden;
    border: 1px solid #e0e8f1;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.08);
  }

  .control-device-mobile-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    padding: 12px;
    border-bottom: 1px solid #e4edf4;
    background: #f5faff;
  }

  .control-device-mobile-card header > div {
    display: grid;
    min-width: 0;
    gap: 2px;
  }

  .control-device-mobile-card header span:first-child,
  .control-device-mobile-card dt {
    color: #71869a;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
  }

  .control-device-mobile-card a {
    color: #0874c9;
    font-size: 14px;
    font-weight: 800;
    overflow-wrap: anywhere;
    text-decoration: none;
  }

  .control-device-mobile-status {
    flex: 0 0 auto;
    padding: 5px 8px;
    border-radius: 999px;
    background: #e7f8e8;
    color: #15823a;
    font-size: 10px;
    font-weight: 700;
  }

  .control-device-mobile-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 0;
  }

  .control-device-mobile-card dl > div {
    min-width: 0;
    padding: 10px;
    border-bottom: 1px solid #edf2f6;
  }

  .control-device-mobile-card dl > div:nth-child(odd) {
    border-right: 1px solid #edf2f6;
  }

  .control-device-mobile-card dt,
  .control-device-mobile-card dd {
    margin: 0;
  }

  .control-device-mobile-card dd {
    margin-top: 3px;
    overflow-wrap: anywhere;
    color: #24486e;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
  }

  .control-device-mobile-card dd a {
    font-size: 12px;
  }

  .control-devices-mobile-empty {
    display: grid;
    min-height: 180px;
    place-items: center;
    align-content: center;
    gap: 8px;
    border: 1px solid #e0e8f1;
    border-radius: 16px;
    background: #fff;
    color: #60798f;
    text-align: center;
  }

  .control-devices-mobile-empty p {
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/controlDevices.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;EACpB;;EAEA;;;;;IAKE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;uEACqE;EACrE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,8CAA8C;EAChD;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,4CAA4C;EAC9C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;6BAC2B;EAC3B;IACE,wCAAwC;IACxC,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;;IAEE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,QAAQ;EACV;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["@media (min-width: 768px) {\n  html.control-devices-page-lock {\n    overflow-y: hidden;\n  }\n\n  body:has(.control-devices-page) #root,\n  body:has(.control-devices-page) .wrapper,\n  .control-devices-page,\n  .control-devices-page .layout-container,\n  .control-devices-page .layout-page {\n    height: 100dvh;\n    min-height: 0;\n  }\n\n  .control-devices-page {\n    overflow: hidden;\n  }\n\n  .control-devices-page .content-wrapper,\n  .control-devices-page .container-fluid.container-p-y {\n    display: flex;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .control-devices-page .container-fluid.container-p-y {\n    flex-direction: column;\n    height: 100%;\n  }\n\n  .control-devices-page .control-devices-heading {\n    flex: 0 0 auto;\n  }\n\n  .control-devices-page .control-devices-table-card {\n    display: flex;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .control-devices-page .control-devices-table-wrapper {\n    height: auto !important;\n    min-height: 0;\n    max-height: 100%;\n    flex: 1 1 auto;\n    overflow-y: auto !important;\n  }\n}\n\n.control-devices-mobile-list {\n  display: none;\n}\n\n@media (max-width: 1199px) {\n  /* En pantallas compactas el menú global se abre desde la hamburguesa como\n     panel lateral, sin reservar una columna fija sobre el contenido. */\n  body.control-devices-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  body.control-devices-responsive-page .sidenav---sidenav---_2tBP {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 12000;\n    width: 0;\n    min-width: 0;\n    overflow: hidden;\n    transform: translateX(-100%);\n    transition: width .2s ease, transform .2s ease;\n  }\n\n  body.control-devices-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n    width: min(280px, 86vw);\n    min-width: min(280px, 86vw);\n    overflow-y: auto;\n    transform: translateX(0);\n    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);\n  }\n\n  body.control-devices-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {\n    display: block;\n  }\n\n  body.control-devices-responsive-page .barra-responsive-offcanvas {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    z-index: 13000;\n  }\n\n  body.control-devices-responsive-page .offcanvas-backdrop {\n    z-index: 12990;\n  }\n\n  /* Igual que el detalle: el color lo aporta el fondo de la pantalla, no una\n     capa opaca del navbar. */\n  .control-devices-page #layout-navbar.custom-navbar-admin {\n    background-color: transparent !important;\n    background-image: none !important;\n    box-shadow: none !important;\n  }\n\n  .control-devices-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .control-devices-page #layout-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .control-devices-page #layout-navbar .app-brand-link img {\n    width: min(190px, 100%);\n    height: 56px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .control-devices-page #layout-navbar .navbar-nav-right {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n  }\n\n  .control-devices-page #layout-navbar .navbar-actions {\n    gap: 4px;\n  }\n}\n\n@media (max-width: 767px) {\n  .control-devices-page {\n    min-height: 100dvh;\n    overflow-x: hidden;\n    background: #f5f7fb;\n  }\n\n  .control-devices-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .control-devices-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n  }\n\n  .control-devices-page .content-wrapper {\n    padding: 0 12px calc(78px + env(safe-area-inset-bottom));\n  }\n\n  .control-devices-page .container-fluid.container-p-y {\n    padding: 16px 0 18px !important;\n  }\n\n  .control-devices-page .control-devices-heading {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 48px;\n    gap: 8px;\n    margin: 0 0 14px;\n  }\n\n  .control-devices-page .control-devices-heading > [class*=\"col-\"] {\n    width: auto;\n    max-width: none;\n    padding: 0;\n  }\n\n  .control-devices-page .control-devices-heading > :first-child {\n    grid-column: 1 / -1;\n  }\n\n  .control-devices-page .control-devices-heading > :nth-child(2) {\n    grid-column: 1;\n  }\n\n  .control-devices-page .control-devices-heading > :nth-child(3) {\n    grid-column: 2;\n  }\n\n  .control-devices-page .label_trafico {\n    display: block;\n    margin: 0 !important;\n    color: #1c3558;\n    font-size: 25px !important;\n    line-height: 1.15;\n    letter-spacing: -0.03em;\n  }\n\n  .control-devices-page .input-group {\n    height: 48px;\n    overflow: hidden;\n    border: 1px solid #d9e4ef;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);\n  }\n\n  .control-devices-page .input-group-text,\n  .control-devices-page #searchDevices {\n    border: 0;\n    background: #fff;\n  }\n\n  .control-devices-page #searchDevices {\n    min-width: 0;\n    color: #234365;\n    font-size: 15px;\n  }\n\n  .control-devices-page .control-devices-heading .btn {\n    width: 48px;\n    height: 48px;\n    margin: 0 !important;\n    padding: 0;\n    border-color: #8fa5bb;\n    border-radius: 12px;\n    background: #fff;\n    color: #4d6c8f;\n  }\n\n  .control-devices-page .control-devices-table-wrapper {\n    display: none;\n  }\n\n  .control-devices-page .control-devices-table-card {\n    overflow: visible;\n    border: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .control-devices-mobile-list {\n    display: grid;\n    gap: 12px;\n  }\n\n  .control-device-mobile-card {\n    overflow: hidden;\n    border: 1px solid #e0e8f1;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.08);\n  }\n\n  .control-device-mobile-card header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 12px;\n    border-bottom: 1px solid #e4edf4;\n    background: #f5faff;\n  }\n\n  .control-device-mobile-card header > div {\n    display: grid;\n    min-width: 0;\n    gap: 2px;\n  }\n\n  .control-device-mobile-card header span:first-child,\n  .control-device-mobile-card dt {\n    color: #71869a;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: .02em;\n    text-transform: uppercase;\n  }\n\n  .control-device-mobile-card a {\n    color: #0874c9;\n    font-size: 14px;\n    font-weight: 800;\n    overflow-wrap: anywhere;\n    text-decoration: none;\n  }\n\n  .control-device-mobile-status {\n    flex: 0 0 auto;\n    padding: 5px 8px;\n    border-radius: 999px;\n    background: #e7f8e8;\n    color: #15823a;\n    font-size: 10px;\n    font-weight: 700;\n  }\n\n  .control-device-mobile-card dl {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    margin: 0;\n  }\n\n  .control-device-mobile-card dl > div {\n    min-width: 0;\n    padding: 10px;\n    border-bottom: 1px solid #edf2f6;\n  }\n\n  .control-device-mobile-card dl > div:nth-child(odd) {\n    border-right: 1px solid #edf2f6;\n  }\n\n  .control-device-mobile-card dt,\n  .control-device-mobile-card dd {\n    margin: 0;\n  }\n\n  .control-device-mobile-card dd {\n    margin-top: 3px;\n    overflow-wrap: anywhere;\n    color: #24486e;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.3;\n  }\n\n  .control-device-mobile-card dd a {\n    font-size: 12px;\n  }\n\n  .control-devices-mobile-empty {\n    display: grid;\n    min-height: 180px;\n    place-items: center;\n    align-content: center;\n    gap: 8px;\n    border: 1px solid #e0e8f1;\n    border-radius: 16px;\n    background: #fff;\n    color: #60798f;\n    text-align: center;\n  }\n\n  .control-devices-mobile-empty p {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
